import { z } from 'zod';

import { Navigate } from '@tanstack/react-router';

import { createFileRoute } from '@tanstack/react-router';

import { BrandInterface } from './-components/brand-interface';
import { useAuthContext } from '@web/auth';
import { hasPermission } from '@shared/auth';

export const brandsSearchSchema = z.object({
  name: z.string({ description: 'Name' }).optional(),
});

export const Route = createFileRoute('/dashboard/admin/brands/')({
  component: View,

  validateSearch: brandsSearchSchema,
});

function View() {
  const { user } = useAuthContext();

  if (!user) return null;

  if (!hasPermission(user, 'brands_module', 'access')) {
    return <Navigate to="/dashboard" />;
  }

  return <BrandInterface />;
}
